/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import dynamic from "next/dynamic";

import ChannelCard from "./ChannelCard";
import type { Channel } from "./SearchScreen";

import styles from "./Channels.module.scss";

const LinkWithLocale = dynamic(() => import("components/LinkWithLocale"));

export interface ChannelsProps {
  channels: Channel[];
}

const Channels = ({ channels }: ChannelsProps) => {
  return (
    <div className={styles.channels}>
      {channels.map((channel) => (
        <LinkWithLocale key={channel.url} href={channel.url}>
          <a>
            <ChannelCard icon={channel.icon} />
          </a>
        </LinkWithLocale>
      ))}
    </div>
  );
};

export default Channels;
